import styled from 'styled-components';

export const Wrapper = styled.div`
  img {
    border-radius: 16px;
    animation: animateThumb 0.5s;

    :hover {
      opacity: 0.8;
    }

    /* elevation */
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.19), 0 3px 3px rgba(0, 0, 0, 0.23);

    @keyframes animateThumb {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
  }

  .card {
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
  }

  .book-title {
    @media screen and (max-width: 576px) {
      font-size: 1rem;
    }
  }
  .book-author {
    @media screen and (max-width: 576px) {
      font-size: 0.8rem;
    }
    color: gray;
  }

  .progress-bar {
    background-color: var(--brandSecondary);
  }
`;
